// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const CANNOT_CONTAIN_SLASHES = 'Value cannot contain \\ or /'
export const INVALID_INPUT = 'Invalid input.'
export const INVALID_EXTENDED_NUMBER_RANGE_FORMAT = 'Invalid format. Must be like "1:3, 5, 7, 8:10"'
export const INVALID_NAME_VALUE = 'Characters must be A-Z 0-9 ( ) # _ - / & or (space)'
export const INVALID_NUMBER_RANGE_FORMAT = 'Invalid format. Valid formats: 4 or 1:7'
export const MUST_BE_ALPHANUMERIC = 'Must be alphanumeric.'
export const MUST_BE_GREATER_THAN_OR_EQUAL_ZERO = 'Must be greater than or equal zero.'
export const MUST_BE_GREATER_THAN_ZERO = 'Must be greater than zero.'
export const MUST_BE_LESS_THAN_OR_EQUAL_ZERO = 'Must be less than or equal 0.'
export const MUST_BE_LESS_THAN_ZERO = 'Must be less than zero.'
export const MUST_BE_NUMERICAL_VALUE = 'Must be numerical value.'
export const MUST_SEARCH_AT_LEAST_ONE_VALUE = 'Must search by at least one value'
export const REQUIRED = 'Required.'
export const TOO_MANY_RESULTS = 'Too many results returned. Please refine your search.'
export const UNCAUGHT_ERROR = 'An uncaught error has occurred'
